module.exports = __webpack_public_path__ + "static/media/award.feb0bc2a.svg";